//Image imports
import defaultVessel from "../../../assets/images/vessels/ship-images/default_vessel_image.png";

const VesselImage = () => {
  return defaultVessel;
};

export default VesselImage;
